var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTakePicture(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.505,
    height: 15.208,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17",
    fill: "#5200f1",
    stroke: "#5200f1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 177",
    d: "M.5 4.85v7.724a2.138 2.138 0 002.136 2.136h13.233a2.138 2.138 0 002.136-2.136V4.85a2.034 2.034 0 00-2.033-2.033h-2.843l-.068-.3A2.6 2.6 0 0010.517.499H7.984A2.6 2.6 0 005.44 2.517l-.068.3H2.533A2.036 2.036 0 00.5 4.85zm5.223-1.16a.435.435 0 00.425-.34l.146-.636a1.728 1.728 0 011.69-1.34h2.533a1.728 1.728 0 011.69 1.34l.146.636a.439.439 0 00.425.339h3.19a1.157 1.157 0 011.159 1.161v7.724a1.261 1.261 0 01-1.261 1.261H2.636a1.261 1.261 0 01-1.261-1.263V4.85a1.157 1.157 0 011.158-1.16z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 178",
    d: "M9.253 12.459a3.676 3.676 0 10-3.676-3.676 3.682 3.682 0 003.676 3.676zm0-6.477a2.8 2.8 0 11-2.8 2.8 2.805 2.805 0 012.8-2.798z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakePicture);
export default __webpack_public_path__ + "static/media/TakePicture.e5ca9c8d9811b4c0a6bd02a6cf8ab4ae.svg";
export { ForwardRef as ReactComponent };